<template>
  <div>
    <Navigation />
    <div class="main">
      <div class="row">
        <div class="col-sm-6 col-lg-3 card-height">
          <div class="card cardStyle card-height">
            <div class="card-header">
              <h3 style="color: rgb(18, 112, 92)">Users</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 p-0">
                  <ul class="list-unstyled">
                    <li>
                      <!-- <router-link :to="{ name: 'users', params: { type: 'total' } }" style="color: inherit; text-decoration: none"> -->
                      <div
                        class="justify-space-between pointer"
                        v-on:click="linkTo('totalusers', 'total')"
                      >
                        <h5
                          class="m-3 just"
                          v-on:click="linkTo('totalusers', 'total')"
                        >
                          <span> Total users: {{ usersInfo.totalUsers }}</span>
                          <img
                            class="link-img"
                            src="../assets/link.svg"
                            alt="background"
                          />
                        </h5>
                      </div>
                    </li>
                    <li>
                      <div
                        v-on:click="linkTo('activeusers', 'active')"
                        class="justify-space-between pointer"
                      >
                        <h5 class="m-3">
                          <span>
                            Active users: {{ usersInfo.activeUsers }}</span
                          >

                          <img
                            class="link-img"
                            src="../assets/link.svg"
                            alt="background"
                          />
                        </h5>
                      </div>
                    </li>
                    <li>
                      <div
                        v-on:click="linkTo('nonactiveusers', 'nonactive')"
                        class="justify-space-between pointer"
                      >
                        <h5 class="m-3">
                          Not active users: {{ usersInfo.notActiveUsers }}
                          <img
                            class="link-img"
                            src="../assets/link.svg"
                            alt="background"
                          />
                        </h5>
                      </div>
                    </li>
                    <li>
                      <div
                        v-on:click="linkTo('bannedusers', 'banned')"
                        class="justify-space-between pointer"
                      >
                        <h5 class="m-3">
                          Banned users: {{ usersInfo.bannedUsers }}
                          <img
                            class="link-img"
                            src="../assets/link.svg"
                            alt="background"
                          />
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 p-0">
                  <span>
                    <i
                      class="fa fa-users fa-7x"
                      aria-hidden="true"
                      style="color: rgb(18, 112, 92)"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
        <!-- ----------------------Packaging START HERE---------------------- -->
        <div class="col-sm-6 col-lg-3 card-height">
          <router-link
            :to="{ name: 'packaging' }"
            style="color: inherit; text-decoration: none"
          >
            <div class="card cardStyle card-height">
              <div class="card-header">
                <h3 style="color: rgb(18, 112, 92)">Packagings</h3>
              </div>
              <div class="card-body mt-3">
                <div class="row">
                  <div class="col-sm-12">
                    <ul class="list-unstyled">
                      <li>
                        <h5>Total packages: {{ totalPackaging }}</h5>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row mt-4 pt-1">
                  <div class="col-sm-12">
                    <span>
                      <i
                        class="fas fa-box-open fa-7x"
                        style="color: rgb(18, 112, 92)"
                      >
                      </i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
          </router-link>
        </div>
        <!-- ----------------------Machines START HERE---------------------- -->
        <div class="col-sm-6 col-lg-3 card-height">
          <router-link
            :to="{ name: 'machines' }"
            style="color: inherit; text-decoration: none"
          >
            <div class="card cardStyle card-height">
              <div class="card-header">
                <h3 style="color: rgb(18, 112, 92)">Machines</h3>
              </div>
              <div class="card-body mt-4">
                <div class="row">
                  <div class="col-sm-12">
                    <ul class="list-unstyled">
                      <li>
                        <h5>Total Machines: {{ totalMachines }}</h5>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row mt-4 pt-1">
                  <div class="col-sm-12">
                    <span>
                      <i
                        class="fas fa-tablet-alt fa-7x"
                        style="color: rgb(18, 112, 92)"
                      >
                      </i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
          </router-link>
        </div>
        <!-- ----------------------Transactions START HERE---------------------- -->
        <div class="col-sm-6 col-lg-3">
          <div class="card cardStyle card-height">
            <div class="card-header">
              <h3 style="color: rgb(18, 112, 92)">Transactions</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <ul class="list-unstyled">
                    <li>
                      <h5>
                        Total transactions:
                        {{ transactionInfo.totalTransactions }}
                      </h5>
                    </li>
                    <li
                      class="pointer"
                      v-on:click="linkTo('transactions', 'banned')"
                    >
                      <h5>
                        Incoming transactions:
                        {{ transactionInfo.totalIncoming }}
                        <img
                          class="link-img"
                          src="../assets/link.svg"
                          alt="background"
                        />
                      </h5>
                    </li>
                    <li
                      class="pointer"
                      v-on:click="linkTo('transactionsoutgoing', 'banned')"
                    >
                      <h5>
                        Outgoing transactions:
                        {{ transactionInfo.totalOutgoing }}
                        <img
                          class="link-img"
                          src="../assets/link.svg"
                          alt="background"
                        />
                      </h5>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row mt-2 pt-1">
                <div class="col-sm-12">
                  <span>
                    <i
                      class="fas fa-qrcode fa-7x"
                      style="color: rgb(18, 112, 92)"
                    >
                    </i>
                  </span>
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
import Navigation from '@/views/Navigation.vue';
import axios from 'axios';
import store from './../store/index';
export default {
  components: {
    Navigation,
  },
  data() {
    return {
      usersInfo: {
        totalUsers: 0,
        notActiveUsers: 0,
        activeUsers: 0,
        bannedUsers: 0,
      },
      totalMachines: 0,
      totalPackaging: 0,
      transactionInfo: {
        totalTransactions: 0,
        totalOutgoing: 0,
        totalIncoming: 0,
      },
    };
  },
  mounted() {
    this.fetchResults();
  },
  methods: {
    linkTo(name, filter) {
      this.$router.push({ name, params: { filter } });
    },
    del() {
      this.$data.deleteTransaction = true;
    },
    fetchResults() {
      axios
        .get(
          store.state.BASE_URI + 'admin/dashboard/load_dashboard_statistics',
          {
            headers: { Authorization: localStorage.getItem('accessToken') },
            params: {},
          },
        )
        .then((res) => {
          const stats = res.data.results.userStatistics;
          this.usersInfo.totalUsers = stats.userStats[0].total_users;
          this.usersInfo.notActiveUsers = stats.userStats[0].not_active_users;
          this.usersInfo.activeUsers = stats.userStats[0].active_users;
          this.usersInfo.bannedUsers = stats.userStats[0].banned_users;
          this.totalMachines =
            res.data.results.totalMachines.results[0].number_of_machines;
          this.totalPackaging =
            res.data.results.totalPackaging.results[0].number_of_packagings;
          this.transactionInfo.totalTransactions =
            res.data.results.totalTransactions[0].total_transactions;
          this.transactionInfo.totalOutgoing =
            res.data.results.totalTransactions[0].total_out;
          this.transactionInfo.totalIncoming =
            res.data.results.totalTransactions[0].total_incoming;
        })
        .catch((err) => err);
    },
  },
  computed: {
    //    users() {
    //      return this.$store.getters.getUsers;
    //    },
  },
  created() {
    //    this.$store.dispatch("fetchUsers")
  },
};
</script>

<style src="../css/style.css"></style>
